export type TaxonomyFieldType =
  | 'boolean'
  | 'integer'
  | 'number'
  | 'enum'
  | 'string'
  | 'object'
  | 'array';

export interface TaxonomyField {
  key: string;
  type: TaxonomyFieldType;
  description?: string;
  enumValues?: (string | number)[];
}

/**
 * Flatten an agent's output JSON Schema (classifier taxonomy or quality rubric)
 * into typed fields for the "expected output" editor. Booleans become labels/
 * flags; everything else is data (numbers, enums, strings, and JSON for
 * object/array fields).
 */
export function parseSchemaFields(schema: Record<string, unknown> | undefined): TaxonomyField[] {
  const props = (schema as { properties?: Record<string, unknown> } | undefined)?.properties;
  if (!props) return [];

  return Object.entries(props).map(([key, raw]) => {
    const v = (raw ?? {}) as { type?: string; description?: string; enum?: (string | number)[] };
    let type: TaxonomyFieldType;
    if (v.type === 'boolean') type = 'boolean';
    else if (v.type === 'integer') type = 'integer';
    else if (v.type === 'number') type = 'number';
    else if (v.type === 'array') type = 'array';
    else if (v.type === 'object') type = 'object';
    else if (v.type === 'string' && Array.isArray(v.enum)) type = 'enum';
    else type = 'string';

    return {
      key,
      type,
      description: v.description,
      enumValues: Array.isArray(v.enum) ? v.enum : undefined,
    };
  });
}
